<template>
  <div @click="showField" :class="getClasses()">
    <div class="field-header">
      <div class="field-label" v-show="showLabel">{{ customField.label }}</div>
      <div class="last-updated" v-if="customField.field_type == 'wysiwyg' && customField.updated_at && updatedOnTop == true">
        Last updated {{ customField.updated_at | moment('MMM D HH:mm a') }}
      </div>
    </div>
    <div class="field-wrap" v-if="customField.field_type == 'priority'">
        <div class="priority-rating" @click="setPriority(customField)">
          <vue-star-rate
            :rateRange="customField.value ? Number(customField.value) : 0"
            :maxIcon="5"
            :iconHeight="17"
            :iconWidth="17"
            :hasCounter="false"
            :key="'del-priority-'+Math.random()+deliverable.id"
            iconColor="#4C9850"
            iconColorHover="#4C9850"
            iconShape="circle"
          ></vue-star-rate>
        </div>
    </div>
    <div class="field-wrap" v-if="customField.field_type == 'wysiwyg'">
        <ckeditor
          :readOnly="!userAbilities.editMediaCall || deliverable.permissions.viewOnly"
          editorUrl="/js/ckeditor/ckeditor.js"
          ref="customInput"
          v-model="customField.value"
          :id="'custom-field-'+_uid"
          :config="editorConfig"
          @input="changed=true"
          @blur="checkChangedFieldValue(customField)"
          @ready="changed=false"
        ></ckeditor>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'textarea'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"  :title="customField.value"
        v-b-tooltip.hover
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="custom-field">
        <textarea
          :rows="rows"
          ref="customInput"
          class="form-control custom-inputs"
          v-show="editing"
          v-click-outside="outside"
          @change="updateFieldValue(customField)"
          @blur="editing = false"
          v-model="customField.value"
        />
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'select'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="custom-field">
        <multiselect
          ref="customInput"
          v-click-outside="outside"
          v-model="customField.value"
          :show-labels="false"
          :options="getOptions"
          :multiple="false"
          v-show="editing"
          @close="editing=false"
          @input="updateFieldValue(customField); editing = false"
        ></multiselect>
      </div>
    </div>

    <div class="field-wrap no-icon" v-if="customField.field_type == 'status'">
      <span
        v-if="customField.value"
        class="exclude-outside-click field-value status-field-value"
        :style="{ backgroundColor: parseValue(customField.value).color || customField.value.color }"

      >{{ parseValue(customField.value).name || customField.value.name }}</span>
      <span
        v-if="!customField.value"
        class="exclude-outside-click field-value"
        v-show="!editing"
      >Click to set...</span>
      <div class="custom-field status-field">
        <multiselect
          ref="customInput"
          :searchable="false"
          v-show="editing"
          v-click-outside="outside"
          v-model="customField.value"
          :options="getOptions"
          @close="editing=false"
          @input="updateFieldValue(customField);"
          @select="editing=false"
          :custom-label="customLabel"
          :show-labels="false">
          <template slot="option" slot-scope="props">
            <div :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">{{ props.option.name }}</div>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="field-wrap field-wrap-users no-icon" v-if="customField.field_type == 'users'">
      <div class="field-value  exclude-outside-click">
      <span class="info-bubbles">
        <span
          v-b-tooltip.hover
          :title="customField.userName"
          class="exclude-outside-click field-value initials badge badge-primary"
          style="display: inline-block"
        >
          {{ (customField.userName || 'Click to set...') | textInitials }}
        </span>
      </span>
      <div class="add-multiselect-group">
      <plus-button/>
      <div class="custom-field user-field custom-multiselect" v-show="editing">
        <multiselect
          ref="customInput"
          v-click-outside="outside"
          v-model="selectedUser"
          :options="allUsers"
          :show-labels="false"
          :multiple="false"
          open-direction="bottom"
          label="name"
          track-by="id"
          @close="editing=false"
          @input="updateFieldValue(customField); editing = false"
        ></multiselect>
      </div>
    </div>
    </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'datepicker'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"
      >{{ customField.value || new Date() | moment("DD MMM, YYYY") }}</span>
      <div class="custom-field">
        <vuejs-datepicker
          ref="customDatepicker"
          :format="customDateFormat"
          v-click-outside="outside"
          name="due_date"
          v-show="editing"
          v-model="customField.value"
          @input="updateFieldValue(customField)"
          @selected="dateSelected=true"
          input-class="custom-datepicker form-control"
          :typeable="true"
        ></vuejs-datepicker>
      </div>
    </div>

    <span v-if="customField.field_type == 'file'">
      <input type="file" />
    </span>

    <span v-if="customField.field_type == 'radio'">
      <label
        class="ml-2"
        v-for="(radioValue, index) in parseValue(customField.value_set)"
        :key="'radio'+index"
      >
        <input
          @change="updateFieldValue(customField)"
          type="radio"
          :value="radioValue"
          v-model="customField.value"
        />
        {{ radioValue }}
      </label>
    </span>

    <div class="last-updated last-updated-below" v-if="customField.field_type == 'wysiwyg' && customField.updated_at && updatedOnTop == false">
      Last updated {{ customField.updated_at | moment('MMM D HH:mm a') }}
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters } from "vuex";
import vueStarRate from "vue-js-star-rating";

export default {
  name: "CustomFields",
  // props: ["customField", "users", "showLabel"],
  props: {
    customField:Object,
    users: Array,
    showLabel: {
      type:Boolean,
      default: true
    },
    updatedOnTop: {
      type:Boolean,
      default: true
    },
    rows: {
      type:Number,
      default: 10
    },
    deliverable: Object
  },
  data() {
    return {
      exclamationCircle: '',
      editing: false,
      dateSelected: false,
      changed:false,
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      }
    };
  },
  computed: {
    ...mapGetters(["allUsers", "userAbilities"]),
    _: function() {
      return _;
    },
    selectedUser: {
      get() {
        return this.allUsers.find(user => user.id == this.customField.value);
      },
      set(newValue) {
        this.customField.userName = newValue.name;
        this.customField.value = newValue.id;
      }
    },
    getOptions() {
      if (this.customField) {
        if (this.customField.value_set) {
          let parsed = this.parseValue(this.customField.value_set);
          if (parsed == false) {
            return [];  // if we don't check for false... it thows up errors
          } else {
            // build value and text
            return parsed;
          }
        }
      }
      return [];
    }
  },
  components: {
    "vuejs-datepicker": Datepicker,
    vueStarRate
  },
  methods: {
    ...mapActions(["updateFieldValue"]),
    userCanEditProject() {
      const userId = localStorage.getItem("userId");
      const project = this.deliverable;

			if (this.userAbilities.accessAllProjects) {
				return true;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}
      console.log('>>>', this.userAbilities, isManager)
			return (this.userAbilities.editProject && isManager);
    },
    setPriority(customField) {
      let priority = $('.priority-rating .vue-star-rate ul.list li.active').length;
      customField.value = priority;
      this.updateFieldValue(customField);
    },
    customLabel({ name }) {
      return name
    },
    checkChangedFieldValue(customField) {
      if (this.changed) {
        this.changed = false;
        this.updateFieldValue(customField);
      }
      // if(typeof window.LIT3 !== 'undefined') {
      //   clearTimeout(window.LIT3);
      // }
      // window.LIT3 = setTimeout(() => {
      //   if (this.changed) {
      //     // this.changed = false
      //     this.updateFieldValue(customField);
      //   }
      // }, 1000);
    },
    getClasses() {
      let cl = "field-container";
        if (this.customField) {
          if(this.customField.field_key) {
            return " field-container--" + this.customField.field_key;
          }
        }
        return cl;
    },
    customDateFormat(date) {
      return this.$moment(date).format("DD MMM, YYYY");
    },
    parseValue(str) {
      try {
          return JSON.parse(str);
      } catch (e) {
          return false;
      }
    },
    showField() {
      console.log('<<<', this.userCanEditProject())
      if(!this.userCanEditProject()) return;
      if(this.editing && !this.dateSelected) return;
      this.editing = true;
      this.$nextTick(() => {
        if (typeof this.$refs.customInput != "undefined") {
          if(this.customField.field_type == 'wysiwyg') {
          } else {
            if (typeof this.$refs.customInput.quill != "undefined") {
              this.$refs.customInput.quill.focus();
            } else if (typeof this.$refs.customInput.$el != "undefined") {
              this.$refs.customInput.$el.focus();
            } else {
              this.$refs.customInput.focus();
            }
          }
        } else if(typeof this.$refs.customDatepicker != "undefined") {
          // this.$refs.customDatepicker.$children[0].$emit('showCalendar')
          if(!this.dateSelected) {
            this.$refs.customDatepicker.showCalendar()
            this.$refs.customDatepicker.$el.querySelector('input').focus()
          } else if(this.dateSelected) {
            this.dateSelected = false
            this.editing = false
          }

        }
      });
    },
    getStatuses(dataJson) {
      let data = this.parseValue(dataJson),
        options = [];
      data.forEach(status => {
        options.push(status.name)
      });
      return options;
    },
    outside() {
      this.editing = false
      this.dateSelected = false
    }
  },
  mounted() {
    let self = this;
    window.addEventListener("keyup", function(e) {
      if (e.keyCode === 27) {
        self.editing = false
        self.dateSelected = false
      }
    });
  },
};
</script>

<style>
</style>
